import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import { FiArrowRight, FiAlertTriangle, FiZap, FiTarget } from 'react-icons/fi';

const PRIORITY_META = [
  { label: 'Critical Priority', icon: FiAlertTriangle, bg: 'bg-red-50', border: 'border-red-200', badge: 'bg-red-600', num: 'bg-red-600', accent: 'text-red-600' },
  { label: 'High Priority', icon: FiZap, bg: 'bg-orange-50', border: 'border-orange-200', badge: 'bg-orange-500', num: 'bg-orange-500', accent: 'text-orange-600' },
  { label: 'Medium Priority', icon: FiTarget, bg: 'bg-blue-50', border: 'border-blue-200', badge: 'bg-blue-600', num: 'bg-blue-600', accent: 'text-blue-600' },
];

const RecommendationCard = ({ rec, index }) => {
  const meta = PRIORITY_META[index] || PRIORITY_META[2];
  return (
    <div className={`border ${meta.border} ${meta.bg} rounded-xl overflow-hidden`}>
      <div className="flex gap-0">
        {/* Side accent */}
        <div className={`w-1.5 ${meta.num} shrink-0`} />
        <div className="flex-1 p-5">
          <div className="flex items-start gap-4">
            <div className={`w-8 h-8 rounded-lg ${meta.num} text-white flex items-center justify-center font-black text-sm shrink-0`}>
              {index + 1}
            </div>
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-1">
                <span className={`text-[10px] font-bold uppercase tracking-widest ${meta.accent}`}>{meta.label}</span>
              </div>
              <h3 className="font-black text-slate-800 text-[15px] mb-2">{rec.risk}</h3>
              <div className="grid grid-cols-2 gap-3 mb-3">
                <div className="bg-white/70 rounded-lg p-3 border border-white">
                  <div className="text-[9px] font-bold text-slate-400 uppercase tracking-widest mb-1">Business Impact</div>
                  <p className="text-[12px] text-slate-600 leading-snug">{rec.impact}</p>
                </div>
                <div className={`rounded-lg p-3 border ${meta.border} bg-white/50`}>
                  <div className="text-[9px] font-bold text-slate-400 uppercase tracking-widest mb-1">Domain Affected</div>
                  <p className="text-[12px] font-semibold text-slate-700 leading-snug">{rec.domain}</p>
                </div>
              </div>
              <div className={`flex items-center gap-2 ${meta.badge} text-white rounded-lg px-4 py-2.5 text-[12px] font-semibold w-full`}>
                <SafeIcon icon={FiArrowRight} className="shrink-0" />
                <span>{rec.action}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecommendationCard;